import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["content"];
export var extractMessageParams = function extractMessageParams(message) {
  if (typeof message === 'string' || Array.isArray(message)) {
    return {
      message: message
    };
  }

  // Assume this is an object.
  if ('content' in message) {
    var content = message.content,
      extra = _objectWithoutProperties(message, _excluded);
    return _objectSpread(_objectSpread({}, extra), {}, {
      message: content
    });
  }

  // $FlowIssue[prop-missing] doesn't understand the fact that 'content' key is removed
  return message;
};
export var randomString = function randomString() {
  return Math.random().toString(36).substring(7);
};